import React, { useState } from 'react';
import { DragAndDropContainer } from '../../../documentsPortal/standardDocuments/uploadDocuments/DragAndDropContainer';
import { Button } from '../../../../../ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileUpload } from '@fortawesome/pro-light-svg-icons';
import { DocumentSelector } from './DocumentSelector';
import { IUploadDocument } from '../../../../../types/order/documents/upload/interfaces';
import { getAdminDocuments, uploadDocuments } from '../../../../../store/order/documents/adminDocuments/dispatch';
import { useAppDispatch } from '../../../../../store/store';
import { useField } from 'formik';
import { fieldName } from './DocumentSelector.fieldName';
import { IStandardDocumentVersionData } from '../../../../../types/order/documents/shared/interfaces';
import { IDocumentCategory } from '../../../../../types/order/documents/IDocumentCategoryType';
import { toast } from 'react-toastify';
import { ModalTarget } from '../lineItem/ModalTarget.Constant';

interface IAddDocumentToListProps {
  baseName: string;
  categories: IDocumentCategory[];
  data: IStandardDocumentVersionData[];
  documentIdsToExclude: string[];
  orderId: string;
  push: (object: any) => void;
  // This is `any` because the type is awful, and we don't really use it at this time
  // If we do end up wanting to use it, then this will change.
  refetch: () => Promise<any>;
}
export const AddDocumentToList: React.FC<IAddDocumentToListProps> = ({
  baseName,
  categories,
  data,
  documentIdsToExclude,
  orderId,
  push,
  refetch,
}) => {
  const dispatch = useAppDispatch();
  const [{ value: documentIdList }] = useField<string[]>(`${baseName}.${fieldName}`);

  const [showAddDocumentModal, setShowAddDocumentModal] = useState(false);
  const [showDragAndDropArea, setShowDragAndDropArea] = useState(documentIdList.length === 0);

  const onUploadDocuments = async (docsToUpload: IUploadDocument[]) => {
    try {
      await dispatch(
        uploadDocuments(orderId, docsToUpload, data || [], false, async (files: any[]) => {
          await refetch();
          files.forEach((t) => push(t));
        })
      );
      dispatch(getAdminDocuments(orderId, categories));
      toast(`Finished adding document`, { type: 'success' });
    } catch (e) {}
  };

  const onDocumentSelected = (document: string) => {
    push(document);
    setShowDragAndDropArea(false);
    toast(`Finished adding document`, { type: 'success' });
  };

  return (
    <>
      <div className={'flex justify-end p-2'}>
        <Button
          intent={showDragAndDropArea ? 'secondary' : 'primary'}
          onClick={() => setShowDragAndDropArea(!showDragAndDropArea)}
        >
          {showDragAndDropArea ? 'Cancel' : '+ Add Document'}
        </Button>
      </div>
      <div className={'basis-full'}>
        <DragAndDropContainer
          renderTargetId={ModalTarget}
          onUploadDocuments={onUploadDocuments}
          orderId={orderId}
          setShowAddDocumentModal={setShowAddDocumentModal}
          showAddDocumentModal={showAddDocumentModal}
          standardDocumentCategories={categories}
        >
          <div className={'mt-4'}>
            {showDragAndDropArea && (
              <div className={'flex flex-row'}>
                <div className={'grid w-full gap-1'}>
                  <button
                    type={'button'}
                    onClick={() => setShowAddDocumentModal(true)}
                    data-test-id={'upload-document-button-Upload a Document'}
                    className={'border-sm grid rounded-lg border-4 border-dashed border-gray-200 p-4'}
                  >
                    <div>
                      <div>
                        <FontAwesomeIcon icon={faFileUpload} size={'5x'} />
                      </div>
                      <div>Upload a file or drag and drop</div>
                    </div>
                  </button>
                  <DocumentSelector
                    categories={categories}
                    data={data}
                    documentIdsToExclude={documentIdsToExclude}
                    push={onDocumentSelected}
                    readOnly={false}
                  />
                </div>
              </div>
            )}
          </div>
        </DragAndDropContainer>
      </div>
    </>
  );
};
